const headRowsService = {
  item: 'Item',
  name: 'Equipment',
  business: 'Service Types',
  site: 'Frequency'
};

export default headRowsService;
